import lity from 'lity';
import {powerbiComponent} from './_powerbi_utils';

// Sii avvisato! Stai per entrare in una valle di lacrime!
// Il modo in cui ho alterato il comportamento della libreria `lity` non è documentato da nessuna
// parte: l'ho dedotto leggendomi il sorgente della stessa un po' leggendo le issue su GitHub
// ed è quindi soggetto ad esplosioni
// se ci dovessero essere grossi cambiamenti all'interno della libreria. D'altronde non sto usando
// la sua interfaccia pubblica; sono io l'unico da biasimare.
//
// Gli elementi con questo data-attribute sono renderizzati in
// `views/components/video.pug`
document.querySelectorAll('[data-lity-custom-youtube-complianz]').forEach(function(el) {
  el.addEventListener('click', function(ev) {
    let iframe, instance, myYoutubeHandler;
    ev.preventDefault();

    // In base allo stato di accettazione dei cookies ritorna un iFrame adatto ad essere bloccato da
    // Complianz. So che sembrerà atroce. Il tuo istinto non mente.
    // Il punto essenziale qual è? Che Lity metterà in pagina dentro al suo lightbox del nuovo HTML,
    // questo comporta che Complianz non sarà in grado di "agganciarsi" ad esso e quindi bloccarlo.
    // Allora quello che facciamo è di mettere un iFrame così come Complianz lo avrebbe modificato.
    //
    // >>>> OUTDATED! Lo tengo per tenerezza <<<<<<
    // Chiaramente ti verrà l'istinto di insultarmi per avere usato il check della presenza della
    // classe `cmplz-status-deny` su `<body>`, ma dovrai fartene una ragione perché in **mesi** non
    // sono mai riuscito a scoprire una API javascript di Complianz per poter dialogare con esso e
    // quindi poter fare della vera e seria programmazione custom. Se trovi la documentazione
    // scrivimi a alessandro.fazzi@welaika.com, chiunque tu sia e qualsiasi anno tu stia vivendo.~~
    // >>>>>> OUTDATED <<<<<
    //
    // Con complianz 6 hanno aggiunta una funzione JS globale per fare il check dello stato del
    // cookie consent. Sto aprendo una birra per festeggiare.
    //
    // Nel caso in cui i cookies fossero accettati, ritorniamo un normale iFrame
    iframe = function(that) {
      if (!cmplz_has_consent('marketing') && !that.getAttribute('data-bypass')) {
        return "<iframe data-placeholder-image=\"http://img.youtube.com/vi/" + (that.getAttribute('data-video-id')) + "/maxresdefault.jpg\" data-category=\"marketing\" data-service=\"youtube\" data-iframe='youtube-video' class=\"cmplz-placeholder-element cmplz-iframe cmplz-iframe-styles cmplz-video\" data-src-cmplz=\"https://www.youtube.com/embed/" + (that.getAttribute('data-video-id')) + "?feature=oembed&amp;controls=1&amp;hd=1&amp;autohide=1&amp;rel=0\" title=\"FattureWeb\" width=\"640\" height=\"360\" src=\"about:blank\" frameborder=\"0\" allow=\"accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture\" allowfullscreen=\"\"></iframe>";
      } else {
        return "<iframe src=\"https://www.youtube.com/embed/" + (that.getAttribute('data-video-id')) + "?feature=oembed&amp;controls=1&amp;hd=1&amp;autohide=1&amp;rel=0\" frameborder=\"0\" allow=\"accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture\" allowfullscreen=\"\" data-iframe='youtube-video'>";
      }
    };

    // Ritorna il blocco di HTMl che ci serve per renderizzare ciò che vogliamo.
    // È importante che sia una funzione.
    myYoutubeHandler = function(_youtube_video_url) {
      return "<div class=\"component_video\">\n    <div class=\"component_video__content\">\n        <div class=\"component_video--embed style=\"cursor: default;\">\n            " + (iframe(this)) + "\n        </div>\n    </div>\n</div>";
    }.bind(this);

    // A parte le opzioni esotiche che sto passando, questo è uno dei modi standard di chiamare lity
    // Chiamandolo così si chiama l'apertura del lightbox. Noi lo facciamo passando un custom handler
    // per gli URL di YouTube
    instance = lity(this.getAttribute('href'), {
      handlers: Object.assign(lity.options().handlers, {
        youtube: myYoutubeHandler
      }),
      template: "<div class=\"lity\" role=\"dialog\" aria-label=\"Dialog Window (Press escape to close)\" tabindex=\"-1\">\n  <div class=\"lity-wrap\" data-lity-close role=\"document\">\n    <div class=\"lity-loader\" aria-hidden=\"true\">Loading...</div><div class=\"lity-container\">\n      <button class=\"lity-close\" type=\"button\" aria-label=\"Close (Press escape to close)\" data-lity-close>&times;</button>\n      <div class=\"lity-content\"></div>\n    </div>\n  </div>\n</div>"
    });

    // newIframes will appear inside the lightbox, so we need to re-call this function in order to
    // have them polished in a 16/9 ratio
    window.forceResizeComponentVideoYouTubeIframes();
  });
});

document.querySelectorAll('[data-lity-custom-vimeo]').forEach(function(el) {
  el.addEventListener('click', function(ev) {
    let instance;
    ev.preventDefault();

    instance = lity(this.getAttribute('href'), {
      handlers: Object.assign(lity.options().handlers, {
        youtube: null
      }),
      template: "<div class=\"lity\" role=\"dialog\" aria-label=\"Dialog Window (Press escape to close)\" tabindex=\"-1\">\n  <div class=\"lity-wrap\" data-lity-close role=\"document\">\n    <div class=\"lity-loader\" aria-hidden=\"true\">Loading...</div><div class=\"lity-container\">\n      <button class=\"lity-close\" type=\"button\" aria-label=\"Close (Press escape to close)\" data-lity-close>&times;</button>\n      <div class=\"lity-content\"></div>\n    </div>\n  </div>\n</div>"
    });
  });
});

document.querySelectorAll('[data-lity-power-bi]').forEach(function(el) {
  el.addEventListener('click', function(ev) {
    let instance, myPowerbiHandler;
    ev.preventDefault();

    myPowerbiHandler = function(_powerbi_url) {
      return powerbiComponent(this)
    }.bind(this);

    instance = lity(this.getAttribute('href'), {
      handlers: Object.assign(lity.options().handlers, {
        powerbi: myPowerbiHandler
      }),
      template: "<div class=\"lity\" role=\"dialog\" aria-label=\"Dialog Window (Press escape to close)\" tabindex=\"-1\">\n  <div class=\"lity-wrap\" data-lity-close role=\"document\">\n    <div class=\"lity-loader\" aria-hidden=\"true\">Loading...</div><div class=\"lity-container\" style=\"width:90%;\">\n      <button class=\"lity-close\" type=\"button\" aria-label=\"Close (Press escape to close)\" data-lity-close>&times;</button>\n      <div class=\"lity-content\"></div>\n    </div>\n  </div>\n</div>"
    });
  })
});
